import { render, staticRenderFns } from "./buttondelete.vue?vue&type=template&id=4221335d&"
import script from "./buttondelete.js?vue&type=script&lang=js&"
export * from "./buttondelete.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4221335d')) {
      api.createRecord('4221335d', component.options)
    } else {
      api.reload('4221335d', component.options)
    }
    module.hot.accept("./buttondelete.vue?vue&type=template&id=4221335d&", function () {
      api.rerender('4221335d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/buttons/buttondelete.vue"
export default component.exports